import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { RuntimeConfigService } from './runtime-config.service';


@Injectable({
    providedIn: 'root'
})
export class SharedService {
    constructor(private http: HttpClient,
        private config: RuntimeConfigService) {
    }

    getQuestUniqueId() {
        return this.http.get<any>(`${this.config.APIUrl}/api/iacst-questionnaire/uniqueId`);
    }

    saveQuestData(payload) {
        return this.http.post<any>(`${this.config.APIUrl}/api/iacst-questionnaire`, payload);
    }

    updateQuestData(id, payload) {
        return this.http.put<any>(`${this.config.APIUrl}/api/iacst-questionnaire/${id}`, payload);
    }

    //////////////////////////////////////////

    getUrlVars() {
        var vars = [], hash;
        var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
        for (var i = 0; i < hashes.length; i++) {
            hash = hashes[i].split('=');
            vars.push(hash[0]);
            vars[hash[0]] = hash[1];
        }
        return vars;
    }

    performClick(elemId) {
        var elem = document.getElementById(elemId);
        if (elem && document.createEvent) {
            var evt = document.createEvent("MouseEvents");
            evt.initEvent("click", true, false);
            elem.dispatchEvent(evt);
        }
    }
}
